import { createContext } from "react";
import GlobalUserData, { iGlobalUserData } from "@models/GlobalUserData";

export const AppContext = createContext<{
    globalVariables: iGlobalUserData,
}>({
    globalVariables: new GlobalUserData(),
});